<div class="page__content">
  <div class="content__inner">
    <div class="register-form">
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'firma_clave_spinner'">
        <p style="color: white">{{mensajeSpinner}}</p>
      </ngx-spinner>
    </div>
  </div>
</div>
